

export const GetTransactionUrl = (hash: string) => {
    if(process.env.REACT_APP_NODE_ENV === "production") {
        return `https://etherscan.io/tx/${hash}`;
    }
    return `https://sepolia.etherscan.io/tx/${hash}`;
}